@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.passenger.destinations

import com.narbase.letsgo.web.dto.locationpoint.LocationPointDto

data class PassengerDestinationsDto(
    val locations: Array<LocationPointDto>,
)
